import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { SemantriaAPIService } from '../semantria-api.service';
import { BaseConfiguration, ConceptTopicItem, QueryTopicItem } from './configuration.service';

export interface LanguageTemplate extends BaseConfiguration {
  isLanguageTemplate?: boolean;
}

@EnableClassTelemetry()
@Injectable()
export class LanguageTemplateService extends SemantriaAPIService {
  getLanguageTemplates(): Promise<LanguageTemplate[]> {
    return this.get<LanguageTemplate[]>('/language-templates/');
  }

  getLanguageTemplate(configId: string): Promise<LanguageTemplate> {
    return this.get<LanguageTemplate>(`/language-templates/${configId}`);
  }

  getConfigurationItemCounts(configId: string) {
    return this.get(`/language-templates/${configId}/info/`);
  }

  getConceptTopic(configId: string, topicId: string): Promise<ConceptTopicItem> {
    return this.get(`/language-templates/${configId}/concept-topics/${topicId}`);
  }

  getQueryTopic(configId: string, topicId: string): Promise<QueryTopicItem> {
    return this.get(`/language-templates/${configId}/query-topics/${topicId}`);
  }
}
